import { render, staticRenderFns } from "./dashboard-annonceur.vue?vue&type=template&id=abc4acc2&scoped=true&"
import script from "./dashboard-annonceur.vue?vue&type=script&lang=js&"
export * from "./dashboard-annonceur.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-annonceur.vue?vue&type=style&index=0&id=abc4acc2&scoped=true&lang=css&"
import style1 from "./dashboard-annonceur.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc4acc2",
  null
  
)

export default component.exports